import Contact from "components/Contact";
import text from "constants/text";
import Head from "next/head";
import HummingFooter from "pages/components/HummingFooter";
import HummingNav from "pages/components/HummingNav";
import React from "react";
import { ExtendedNextPage } from "types/pages";
import AdditionalBenefits from "./components/AdditionalBenefits";
import ExclusiveBenefits from "./components/ExclusiveBenefits";
import Heading from "./components/Heading";
import MaintenancePlan from "./components/MaintenancePlan";
import WhatYouGet from "./components/WhatYouGet";

import styles from "./styles.module.scss";

const Membership: ExtendedNextPage = () => {
  const {
    heading,
    maintenance_plan: maintenancePlan,
    additional_benefits: additionalBenefits,
    exclusive_access: exclusiveBenefits
  } = text.our_membership;

  return (
    <div className={styles.container}>
      <Head>
        <title>Membership | Humming Homes</title>
        <meta
          name="description"
          content="Get started with your membership today and get end-to-end home management."
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://humminghomes.com/homeowners" />
      </Head>
      <Heading {...heading} />
      <MaintenancePlan {...maintenancePlan} />
      <WhatYouGet {...maintenancePlan} />
      <AdditionalBenefits {...additionalBenefits} />
      <ExclusiveBenefits {...exclusiveBenefits} />
      <Contact />
    </div>
  );
};

Membership.getLayout = (page) => {
  return (
    <div>
      <HummingNav />
      {page}
      <HummingFooter />
    </div>
  );
};

export default Membership;
